import { observer } from 'mobx-react-lite';
import React, { useState, useEffect, useRef } from 'react';
import { GoogleReCaptchaProvider, GoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Captcha, captchaSettings } from 'reactjs-captcha';
import { loadCaptchaEnginge, LoadCanvasTemplate, LoadCanvasTemplateNoReload, validateCaptcha } from 'react-simple-captcha';

const RegisterForm = observer(({ cartStore }) => {
  const password = useRef();
  const cPassword = useRef();
  const register_firstname = useRef();
  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [cPasswordClass, setCPasswordClass] = useState('form-control');
  const [isCPasswordDirty, setIsCPasswordDirty] = useState(false);
  const [isRegisterFirstnamDirty, setIsRegisterFirstnamDirty] = useState(false); 

  const [token, setToken] = useState('')
  const verifyRecaptchaCallback = React.useCallback((token) => { 
    setToken(token)
  }, []);

  useEffect(() => {
    loadCaptchaEnginge(6);
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) { 
        setShowErrorMessage(false);
        setCPasswordClass('form-control is-valid')
      } else {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid')
      }
    }
    if(isRegisterFirstnamDirty){
      if(register_firstname.current.value == '') {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid')

      }
    }
  }, [isCPasswordDirty])

  const checkPasswords = (e) => {
    setIsCPasswordDirty(true);
    if (isCPasswordDirty) {
      if (password.current.value === cPassword.current.value) {
        setShowErrorMessage(false);
        setCPasswordClass('form-control is-valid')
      } else {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid')
      }
    }

  }

  const doSubmit = () => {
    let user_captcha = document.getElementById('user_captcha_input').value;
    let register_firstname = document.getElementById('register_firstname').value;
    let register_lastname = document.getElementById('register_lastname').value; 

    if (validateCaptcha(user_captcha) == true) {
     // alert('Captcha Matched');
      loadCaptchaEnginge(6);
      document.getElementById('user_captcha_input').value = ""; 
    }
    console.log("register name is=>",isRegisterFirstnamDirty);

   // if(isRegisterFirstnamDirty){
      if(register_firstname == '') {
        setShowErrorMessage(true)
        setCPasswordClass('form-control is-invalid') 

      }
   // }



    else {
      // /alert('Captcha Does Not Match');
      document.getElementById('user_captcha_input').value = "";
    }
  };

  console.log("the register form is");
  return (
    <>
      <h5>Benutzerkonto anlegen</h5>
      <fieldset>
        <legend>Persönliche Informationen</legend>
        <div className="row mb-3">
          <div className="col-sm-6 col-md-6">
            <input
              type="text"
              placeholder="Vorname"
              name="register_firstname"
             // className="form-control"
              autoComplete="register register_firstname"
              onChange={(e) =>
                cartStore.updateRegisterForm(
                  'register_firstname',
                  e.target.value,
                )
              }
              className={cPasswordClass}
              id="register_firstname" 
              ref={register_firstname} 

            />
            {}
          </div>

          <div className="col-sm-6 col-md-6">
            <input
              type="text"
              placeholder="Nachname"
              name="register_lastname"
              autoComplete="register_lastname"
              className="form-control"
              onChange={(e) =>
                cartStore.updateRegisterForm('register_lastname', e.target.value)
              }
              id="register_lastname"
            />
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-sm-12 col-md-12">
            <input
              type="email"
              placeholder="E-Mail"
              name="register_email"
              className="form-control"
              id="register_email"
              onChange={(e) =>
                cartStore.updateRegisterForm('register_email', e.target.value)
              }
              autoComplete="register_email"
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Anmeldedaten</legend>
        <div className="row mb-3">
          <div className="col-md-6 col-lg-6 col-sm-12">
            <input
              type="password"
              name="password"
              id="password"
              className="form-control"
              placeholder="Passwort"
              onChange={(e) =>
                cartStore.updateRegisterForm('password', e.target.value)
              }
              autoComplete="password"
              ref={password}
            />
          </div>
          <div className="col-md-6 col-lg-6 col-sm-12">
            <input
              type="password"
              name="confirm_password"
              id="confirm_password"
              ref={cPassword}
              onChange={checkPasswords}
              className={cPasswordClass}
              // onChange={(e) =>
              //   cartStore.updateRegisterForm(
              //     'confirm_password',
              //     e.target.value,
              //   )
              // } 
              placeholder="Passwort bestätigen"
            />
          </div>
        </div>
        <div>
        Um ein sicheres Passwort zu erzeugen, darf es nicht mit deiner E-Mail-Adresse identisch sein, muss mehr als 8 Stellen haben und mindestens eine Zahl und ein Sonderzeichen enthalten. 
        </div>
        <div>
          <div className="col mt-3">
            <LoadCanvasTemplate />
          </div>
          <div className="col mt-3">
            <div><input placeholder="Enter Captcha Value" id="user_captcha_input" name="user_captcha_input" type="text"></input></div>
          </div>

          <div className="col mt-3">
            <div><button className="btn btn-primary" onClick={() => doSubmit()}>Submit</button></div>
          </div>


        </div>
      </fieldset>

    </>
  );
});
export default RegisterForm;  
